import React from "react";

const LazyProfile = React.lazy(() => import("./myProfile"));

const MyProfile = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyProfile {...props} />
  </React.Suspense>
);

export default MyProfile;
